import { RenderIf } from 'react-rainbow-components';
import formatIntlPhoneNumber from 'data/services/phone/formatter';
import useHttpQuery from 'data/firestore/useHttpQuery';
import { Phonenumber } from 'data/firestore/agent/customer/phonenumber/types';
import LoadingShape from 'components/LoadingShape';
import {
    Container, PhoneInfoContainer, PhoneLabel, PhoneType,
} from './styled';
import PhonePickerButton from './PhonePickerButton';

interface CustomerPhonePickerProps {
    agentId?: string;
    customerId?: string;
    callNumber?: string;
    onSwitchPhone?: (phoneNumber: string) => void;
}

const CustomerPhonePicker = ({
    callNumber,
    agentId = '',
    customerId = '',
    onSwitchPhone = () => {},
}: CustomerPhonePickerProps) => {
    const {
        data: phoneNumbers = [],
        isLoading: isLoadingPhoneNumbers,
    } = useHttpQuery<Phonenumber[]>({
        key: ['customer-phone-numbers', customerId],
        pathname: `/agents/${agentId}/customers/${customerId}/phone-numbers`,
        queryOptions: {
            disabled: !agentId || !customerId,
        },
    });

    const phoneType = phoneNumbers.find(
        (phone) => phone.phoneNumber === callNumber,
    )?.phoneType || 'Unknown';

    const sortedPhones = [...phoneNumbers].sort((a) => (a.type === 'primary' ? -1 : 1));

    const formattedPhoneNumber = formatIntlPhoneNumber(callNumber);

    if (isLoadingPhoneNumbers) {
        return (
            <Container>
                <LoadingShape width="10rem" height="1rem" />
            </Container>
        );
    }

    return (
        <Container>
            <PhoneInfoContainer paddingLeft={sortedPhones.length > 1 ? '1.75rem' : undefined}>
                <PhoneLabel>
                    {formattedPhoneNumber}
                </PhoneLabel>
                <RenderIf isTrue={callNumber}>
                    <PhoneType>{phoneType}</PhoneType>
                </RenderIf>
            </PhoneInfoContainer>
            <RenderIf isTrue={sortedPhones.length > 1}>
                <PhonePickerButton
                    value={callNumber}
                    onChange={onSwitchPhone}
                    phoneNumbers={sortedPhones}
                />
            </RenderIf>
        </Container>
    );
};

export default CustomerPhonePicker;
